import { injectReducers } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import { USER_ROLES_WITH_BLOCKED_SITES_ACCESS } from 'utils/constants'
import { UserDoesNotHaveRole, UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import SitesPageContainer from './containers/SitesPageContainer'
import reducer, { actions as userActions } from '../../../Users/routes/CreateUser/modules/CreateUser'
import { getUserRoleIdByStudy } from '../../../../../../../../utils/misc'
import { USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS } from '../../../../../../../../utils/constants'
import { browserHistory } from 'utils/navigation'

const { fetchUserSites } = userActions
// Sync route definition
export default store => ({
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      () => {
        const { params } = nextState
        const { studyID, studyVersionID } = params
        const { userId } = store.getState().user
        const { study } = store.getState()

        const roleId = getUserRoleIdByStudy(store?.getState()?.user, studyID)
        if (USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS.includes(roleId)) {
          browserHistory.push(`/studies/${studyID}/${studyVersionID}/compliance`)
        }

        setPageTitle(`Sites | Study ${studyID} | ${study.currentStudy.platform_name}`)
        injectReducers(store, {
          userReducer: reducer,
        })
        store.dispatch(fetchUserSites({ studyId: studyID, userId }))
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              UserHasScope(
                ['rp', 'rp-no-pii'],
                UserDoesNotHaveRole(USER_ROLES_WITH_BLOCKED_SITES_ACCESS, SitesPageContainer),
                false,
                studyID,
                null,
                study.currentStudy,
              ),
            ),
          ),
        )
      },
      'sites',
    )
  },
})
